import { useRouter } from 'next/router';
import type { FC } from 'react';
import { useMemo } from 'react';
import { Link } from '@app/_components/link';

interface Props {
  url: string;
  text?: string; // if empty, use url as link text
}

export const InsideContentLink: FC<Props> = ({ url, text }) => {
  const { query } = useRouter();
  const noLayout = query['nolayout'] === '1';
  const noNav = query['nonav'] === '1';

  const noLayoutParam = useMemo(() => {
    return noLayout ? `?nolayout=1` : '';
  }, [noLayout]);

  const noNavParam = useMemo(() => {
    return noNav ? `${noLayoutParam ? '&' : '?'}nonav=1` : '';
  }, [noLayoutParam, noNav]);

  return (
    <Link href={`${url}${noLayoutParam}${noNavParam}`}>{text || url}</Link>
  );
};
